import StoreBuilder from '../store-builder';
import { AlerteApi } from '@/api/alertes';
import { CodeDomaine } from '@/model/enum-types/code-domaine';
import { Alerte } from '@/model/alerte';

const builder = new StoreBuilder('alertes');

export type AlerteData = { utilisateur: string, alerte: Alerte }

builder.addStatePart('alertesUtilisateur', null, (utilisateur: string) => AlerteApi.getAllAlertes(CodeDomaine.ENGRAIS, utilisateur), 'NONE', 600);

builder.setActions({
  suspendreAlerte: ({ dispatch }: any, { utilisateur, alerte }: AlerteData) => {
    return AlerteApi.suspendreAlerte(CodeDomaine.ENGRAIS, utilisateur, alerte)
      .then(() => { dispatch('clearCache'); })
      .then(() => dispatch('loadAlertesUtilisateur', utilisateur));
  },
  supprimerAlerte: ({ dispatch }: any, { utilisateur, alerte }: AlerteData) => {
    return AlerteApi.supprimerAlerte(CodeDomaine.ENGRAIS, utilisateur, alerte)
      .then(() => { dispatch('clearCache'); })
      .then(() => dispatch('loadAlertesUtilisateur', utilisateur));
  },
  modifierAlerte: ({ dispatch }: any, { utilisateur, alerte }: AlerteData) => {
    return AlerteApi.modifierAlerte(CodeDomaine.ENGRAIS, utilisateur, alerte)
      .then(() => { dispatch('clearCache'); })
      .then(() => dispatch('loadAlertesUtilisateur', utilisateur));
  },
  creerAlerte: ({ dispatch }: any, { utilisateur, alerte }: AlerteData) => {
    return AlerteApi.ajouterAlerte(CodeDomaine.ENGRAIS, utilisateur, alerte)
      .then(() => { dispatch('clearCache'); })
      .then(() => dispatch('loadAlertesUtilisateur', utilisateur));
  }
});

export default builder.build();
